import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LoadingButton from '@mui/lab/LoadingButton';
import { formatDateLabel } from '../../../../../lib/dayjs';
import { EScheduleSteps, updateScheduleSteps } from '../../../../../features/schedule/schedule-slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { Divider } from '../../../Divider';
import { DialogContent } from '../../styled';
import { IReschedulingConfirmation, useReschedulingConfirmationMutation } from '../../../../../services/schedule.service';
import { clearCalendarSelected, isReSchedule as setIsReschedule } from '../../../../../features/calendar/calendar-slice';
import { getCurrentSchedule } from '../../../JourneyActionManager';
import { ScheduleAnalyticsTrackerInstance } from '../../../../../lib/gtm';

const RescheduleAppointment = () => {
  const {
    schedule: { dateStart, dateStartISO },
    calendar: { withTheSameDoctor, doctorId, calendarSelected, calendarsAvailables, journey, schedule: schedule_select }
  } = useSelector((state: RootState) => state);
  const currentSchedule = getCurrentSchedule(journey);
  const dispatch = useDispatch();
  const [reschedulingConfirmation, { isLoading }] = useReschedulingConfirmationMutation();
  return (
    <>
      <DialogContent>
        <Divider sx={{ marginTop: 0 }} />
        <Typography variant="body1B" sx={{ mb: 1 }}>
          Nova data da consulta
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Typography>{formatDateLabel(dateStart)}</Typography>
          <Button
            variant="inline"
            disabled={isLoading}
            onClick={() => {
              dispatch(
                updateScheduleSteps({
                  currentStep:
                    calendarsAvailables.length > 1 ? EScheduleSteps.returnAppointment : EScheduleSteps.openCalendar,
                  previousStep: calendarsAvailables.length > 1 ? EScheduleSteps.returnAppointment : EScheduleSteps.idle
                })
              );
              if (calendarsAvailables.length > 1) dispatch(clearCalendarSelected());
            }}
          >
            Alterar
          </Button>
        </Box>
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        {currentSchedule && (
          <>
            <LoadingButton
              loading={isLoading}
              variant="contained"
              onClick={() => {
                const payload: IReschedulingConfirmation = {
                  currentScheduleId: currentSchedule.id as string,
                  calendarid: calendarSelected?.id as string,
                  dateStart: dateStartISO
                };

                if (withTheSameDoctor) {
                  payload.userId = doctorId as string;
                }

                if (schedule_select?.rescheduleReason) {
                  payload.reason = schedule_select.rescheduleReason;
                }

                reschedulingConfirmation(payload)
                  .unwrap()
                  .then(resp => {
                    ScheduleAnalyticsTrackerInstance.setProperties({
                      scheduleFlow: 'reschedule_return',
                      scheduleDateStart: dateStart || '',
                      scheduleCalendarId: calendarSelected?.id || '',
                      scheduleCalendarAlias: calendarSelected?.alias || '',
                      scheduleId: currentSchedule?.id || '',
                      scheduleProductId: journey?.product?.id || '',
                      journeyId: resp.journey?.id || ''
                    }).sendGAEvent();
                    dispatch(
                      updateScheduleSteps({ currentStep: EScheduleSteps.sendFile, previousStep: EScheduleSteps.idle })
                    );
                    dispatch(clearCalendarSelected());
                    dispatch(setIsReschedule(true));
                  })
                  .catch(error => {
                    console.log(error);
                  });
              }}
              endIcon={<ArrowForwardIcon />}
            >
              Salvar
            </LoadingButton>
          </>
        )}
      </Box>
    </>
  );
};

export default RescheduleAppointment;
